// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useClickOutside } from "../../Hooks/useClickOutside"; 

// const AddFaqModal = ({ isOpen, onClose, onSave }) => {
//   const [formData, setFormData] = useState({
//     question: "",
//     answer: "",
//   });

//   // ✅ Attach ref to modal container
//   const modalRef = useClickOutside(() => {
//     onClose();
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSave = () => {
//     if (!formData.question || !formData.answer) {
//       alert("Please fill in both fields.");
//       return;
//     }
//     onSave(formData);
//     setFormData({ question: "", answer: "" });
//     onClose();
//   };

//   return (
//     <AnimatePresence>
//       {isOpen && (
//         <>
//           {/* Background Overlay */}
//           <motion.div
//             className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//           />

//           {/* Modal */}
//           <motion.div
//             className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
//             initial={{ scale: 0.9, opacity: 0 }}
//             animate={{ scale: 1, opacity: 1 }}
//             exit={{ scale: 0.9, opacity: 0 }}
//           >
//             {/* ✅ attach ref here */}
//             <div
//               ref={modalRef}
//               className="bg-[#ecf1f5] rounded-2xl shadow-2xl w-full max-w-lg p-6"
//             >
//               {/* Header */}
//               <div className="flex justify-between items-center pb-3 mb-4">
//                 <h2 className="text-2xl font-philosopher text-gray-800">
//                   Add FAQ
//                 </h2>
//                 <button
//                   onClick={onClose}
//                   className="text-gray-500 hover:text-blue-500 transition"
//                 >
//                   ✕
//                 </button>
//               </div>

//               {/* Form */}
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-gray-700 font-medium mb-1">
//                     Question
//                   </label>
//                   <input
//                     type="text"
//                     name="question"
//                     value={formData.question}
//                     onChange={handleChange}
//                     placeholder="Enter your question"
//                     className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none font-poppins"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-gray-700 font-medium mb-1">
//                     Answer
//                   </label>
//                   <textarea
//                     name="answer"
//                     value={formData.answer}
//                     onChange={handleChange}
//                     rows="4"
//                     placeholder="Enter the answer"
//                     className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none font-poppins resize-none"
//                   />
//                 </div>
//               </div>

//               {/* Buttons */}
//               <div className="flex justify-end gap-3 mt-6">
//                 <button
//                   onClick={onClose}
//                   className="px-5 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-poppins transition"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleSave}
//                   className="px-5 py-2 rounded-lg bg-[#b07d17] text-white font-poppins hover:bg-[#8c6312] transition"
//                 >
//                   Save FAQ
//                 </button>
//               </div>
//             </div>
//           </motion.div>
//         </>
//       )}
//     </AnimatePresence>
//   );
// };

// export default AddFaqModal;

import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useClickOutside } from "../../Hooks/useClickOutside";
import { toast } from "react-hot-toast";
const AddFaqModal = ({ isOpen, onClose, onSave, faqData }) => {
  const [formData, setFormData] = useState({ question: "", answer: "" });

  useEffect(() => {
    if (faqData) {
      setFormData({ question: faqData.question, answer: faqData.answer });
    } else {
      setFormData({ question: "", answer: "" });
    }
  }, [faqData]);

  const modalRef = useClickOutside(() => onClose());

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = () => {
    if (!formData.question || !formData.answer) {
      toast.error("Please fill in both fields.");
      return;
    }
    onSave(formData, !!faqData, faqData?._id);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
          >
            <div
              ref={modalRef}
              className="bg-[#ecf1f5] rounded-2xl shadow-2xl w-full max-w-lg p-6"
            >
              <div className="flex justify-between items-center pb-3 mb-4">
                <h2 className="text-2xl font-philosopher text-gray-800">
                  {faqData ? "Edit FAQ" : "Add FAQ"}
                </h2>
                <button
                  onClick={onClose}
                  className="text-gray-500 hover:text-blue-500 transition"
                >
                  ✕
                </button>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Question
                  </label>
                  <input
                    type="text"
                    name="question"
                    value={formData.question}
                    onChange={handleChange}
                    placeholder="Enter your question"
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none font-poppins"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Answer
                  </label>
                  <textarea
                    name="answer"
                    value={formData.answer}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Enter the answer"
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none font-poppins resize-none"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={onClose}
                  className="px-5 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-poppins transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSave}
                  className="px-5 py-2 rounded-lg bg-[#b07d17] text-white font-poppins hover:bg-[#8c6312] transition"
                >
                  {faqData ? "Update FAQ" : "Save FAQ"}
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default AddFaqModal;
